import $ from 'jquery';
import { isValidUrl } from '../engine/helpers/worldHelpers';

let disableClass = 'disabled';
let currentClass = 'current';

const initShopSlider = (products) => {

    $('.slider__slides').empty();
    $('.slider__slide').empty();
    $('.slider__dots').empty();
    $('.slider__slide').removeClass('current');
    $('#slider_left').val(0);
    $('#slider_currentSlide').val(0);

    for (let i = 0; i < products.length; i++) {
      
        const element = products[i];
        let product_image = element.product_image;
        let product_image_src = product_image !== './textures/banner_placeholder_ratio2_1.jpg' ? `./${product_image}` : product_image;
        let descClass = '';
        let priceClass = '';
        let url = '';
        let buyLink = '';
        let btnLabel = 'BUY ITEM';

        if(element.product_url !== ''){
            url = isValidUrl(element.product_url)
            buyLink = element.product_url
        }

        if(element.product_button_label && element.product_button_label !== ''){
            btnLabel = element.product_button_label;
        }

        if(element.product_description == ''){descClass = 'hidden'}
        if(element.product_price == ''){priceClass = 'hidden'}

        const product_name = element.product_name;

        let sliderDOM = `
        <div class="slider__slide" data-index=${i}>
            <div class="slider__img" style="background-image: url(${product_image_src})">
                <div class="slider__price ${priceClass}">${element.product_price}</div>
            </div>
            <div class="slider__title">${product_name}</div>
            <div class="slider__description ${descClass}">${element.product_description}</div>
        `;

        if(url){
            sliderDOM += 
            `<div class="slider__url">
                <a class="button primary" href="${buyLink}" target="_blank">${btnLabel}</a>
            </div>`;
        }

        sliderDOM += '</div>';

        $('.slider__slides').append(sliderDOM);

        $('.slider__dots').append('<span class="slider__dot" data-index=' + i + '>' + '</span>');
    }

    if(products.length < 2){
        $('.shop_item_action_arrow').hide();
        $('.slider__dots').hide();
    }else{
        $('.shop_item_action_arrow').show();
        $('.slider__dots').show();
    }
    
    $('#slider_left').val(0);
    $('.slider__slides').css('transform', 'translateX(-0px)');
    trackCurrent();
    disableArrows();
}

const trackCurrent = () => {
    let currentSlide = parseInt($('#slider_currentSlide').val());
    $('.slider__slide').eq(currentSlide).addClass(currentClass).siblings().removeClass(currentClass);
    $('.slider__dot').eq(currentSlide).addClass(currentClass).siblings().removeClass(currentClass);

    $("#product_display-title").text( $('.slider__slide').eq(currentSlide).children(".slider__title").text() );
}

const getCurrentSliderValues = () => {
    let slideWidth = $('.slider__slides').outerWidth();
    slideWidth = parseInt(slideWidth.toFixed(0));
    let numOfSlides = $('.slider__slide').length;
    let slidesWidth = slideWidth * numOfSlides;
    slidesWidth = parseInt(slidesWidth.toFixed(0));
    let left = parseInt($('#slider_left').val());
    let currentSlide = parseInt($('#slider_currentSlide').val());

    return {
        slideWidth,
        numOfSlides,
        slidesWidth,
        left,
        currentSlide
    };
}

const disableArrows = () => {
    const {slideWidth, slidesWidth, left} = getCurrentSliderValues();

    $('.shop_item_action_arrow').removeClass(disableClass);
    
    if (left === 0) {
        $('.slider__prev').addClass(disableClass);
        return;
    } else if (left === slidesWidth - slideWidth) {
        $('.slider__next').addClass(disableClass);
        return;
    } 
}

const changeSlide = () => {
    let left = parseInt($('#slider_left').val());
    $('.slider__slides').css('transform', 'translateX(-' + left + 'px)');
    trackCurrent();
    disableArrows();
}

const resizeSlider = (num) => {
    $('#slider_left').val(num);
    let left = parseInt($('#slider_left').val());
    let currentSlide = parseInt($('#slider_currentSlide').val());
    if(currentSlide > 1){
        left=left*currentSlide;
        left = left.toFixed(0)
        $('#slider_left').val(left);
    }
    $('.slider__slides').css('transform', 'translateX(-' + left + 'px)');
    trackCurrent();
    disableArrows();
}


export { initShopSlider, getCurrentSliderValues, changeSlide, resizeSlider };